'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promisedFileReader = require('../file/promisedFileReader');

// For some details behind this implementation see:
//      http://code.flickr.net/2012/06/01/parsing-exif-client-side-using-javascript-2/
//      http://stackoverflow.com/questions/20600800/js-client-side-exif-orientation-rotate-and-mirror-jpeg-images
//      http://stackoverflow.com/questions/7584794/
//          accessing-jpeg-exif-rotation-data-in-javascript-on-the-client-side/32490603#32490603
//      https://jsfiddle.net/wunderbart/dtwkfjpg/

// EXIF Format Description:
//      https://www.media.mit.edu/pia/Research/deepview/exif.html

// The EXIF data is stored in the first 128 bytes of the image (supposed to be 64 but some formats spill over)
var EXIF_DATA_BYTES = 128 * 1024;

//
/**
 * -2 = Not a JPEG file
 * -1 = Orientation is not defined
 *  1 = Normal
 *  2 = Horizontally mirrored
 *  3 = Rotated 180 deg
 *  4 = Rotated 180 deg and horizontally mirrored
 *  5 = Rotated 270 deg and horizontally mirrored
 *  6 = Rotated 270 deg
 *  7 = Rotated 90 deg and horizontally mirrored
 *  8 = Rotated 90 deg
 */
/* eslint-disable eqeqeq */
// Util

exports.default = function (file) {
    return (0, _promisedFileReader.readAsArrayBuffer)(file, EXIF_DATA_BYTES).then(function (exifArrayBufferData) {
        // In order to read the array buffer data we should use a data view because this supports endianness
        var exifDataView = new DataView(exifArrayBufferData);

        // EXIF defines different value types that can be encountered:
        /*
         1 = BYTE An 8-bit unsigned integer
         DataView.getUint8
         2 = ASCII An 8-bit byte containing one 7-bit ASCII code. The final byte is terminated with NULL.
         3 = SHORT A 16-bit (2-byte) unsigned integer
         DataView.getUint16
         4 = LONG A 32-bit (4-byte) unsigned integer
         DataView.getUint32
         5 = RATIONAL Two LONGs. The first LONG is the numerator and the second LONG expresses the denominator.
         7 = UNDEFINED An 8-bit byte that can take any value depending on the field definition
         9 = SLONG A 32-bit (4-byte) signed integer (2’s complement notation)
         10 = SRATIONAL Two SLONGs. The first SLONG is the numerator and the second SLONG is the denominator
         */

        // We're reading in the file as an array buffer so ASCII is done for us.

        // TODO Do I need figure to figure out endianness?
        // Start of image (SOI) bytes = 0xFFD8
        if (exifDataView.getUint16(0, false) != 0xFFD8) {
            // Not a JPEG image
            return -2;
        }

        var length = exifDataView.byteLength;
        // Skip the first two bytes as we've already verified they're SOI
        var offset = 2;

        while (offset < length) {
            var marker = exifDataView.getUint16(offset, false);
            offset += 2;

            // APP1 = 2 bytes: 0xFFE1
            // TODO Should I use the below comment somehow?
            // We usually check the last byte of this for the value 0xE1, or 225 in decimal
            // to prevent any endianness problems
            if (marker == 0xFFE1) {
                // TODO Where is this?? Is that maybe what the last else is doing?
                // The next thing we want to know is the size of the APP1 data, we can use this to optimize and
                // know when to stop reading, which is also 2 bytes

                // Next up is the Exif header, which is always the 4 bytes 0x45, 0x78, 0x69, 0x66, or “Exif” in
                // ASCII.
                if (exifDataView.getUint32(offset += 2, false) != 0x45786966) {
                    // eslint-disable-line no-cond-assign
                    // If it does not equal it then there's something wrong with the data
                    return -1;
                }

                // This is always followed up 2 null bytes 0x0000
                // Then begins the TIFF header and then the 0th IFD, where our Exif is stored, followed by the 1st
                // IFD, which usually contains a thumbnail of the image.

                // We are concerned with application segment 1 (APP1).
                // APP2 and others can contain other metadata about this compressed image

                // Once we know we are at APP1 we can move on to the TIFF header which starts with the byte alignment,
                // 0x4949 (II, Intel) or 0x4D4D (MM, Motorola), Intel being little endian and Motorola being big endian
                var little = exifDataView.getUint16(offset += 6, false) == 0x4949;

                // Then we have the tag marker, which is always 0x2A00 (or 0x002A for big endian):
                // “an arbitrary but carefully chosen number (42) that further identifies the file as a TIFF file”

                // Next we have the offset to the first IFD, which is usually 0x08000000, or 8 bytes from the beginning of
                // the TIFF header (The 8 bytes: 0x49 0x49 0x2A 0x00 0x08 0x00 0x00 0x00).
                offset += exifDataView.getUint32(offset + 4, little);

                // Now we can begin parsing the 0th IFD.  - I think that's where we're up to
                var tags = exifDataView.getUint16(offset, little);
                offset += 2;

                for (var i = 0; i < tags; i++) {
                    // Orientation tag = 0x0112
                    if (exifDataView.getUint16(offset + i * 12, little) == 0x0112) {
                        return exifDataView.getUint16(offset + i * 12 + 8, little);
                    }
                }
            } else if ((marker & 0xFF00) != 0xFF00) {
                // Not sure about what this is
                break;
            } else {
                // Not sure about this either, must be jumping to a location
                offset += exifDataView.getUint16(offset, false);
            }
        }

        // Undefined orientation
        return -1;
    });
};

// Other resources:
//      https://gist.github.com/runeb/c11f864cd7ead969a5f0
//      https://jsfiddle.net/orotemo/obvna6qn/1/
//      http://www.daveperrett.com/articles/2012/07/28/exif-orientation-handling-is-a-ghetto/


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/services/image/getExifOrientationData.js
// module id = 2137
// module chunks = 0